<template>
  <div class="report-fs">
    <div style="margin-top: 178px" v-if="pathLogo == m"></div>
    <div style="margin-top: 35px" v-if="pathLogo != m"></div>
    <div class="mlogo t-alignlogo">
      <img class="wlogo" :src="pathLogo" />
    </div>
    <h3 class="text-center fs-head-co">{{ name }}</h3>
    <h3 class="text-center fs-head-co">{{ desc }}</h3>
    <h3 class="text-center fs-head">تقرير قوائم الموظفين</h3>
    <h3 class="text-center fs-head">
      {{ DepartmentId == "" ? "" : data[0].departmentName }}
    </h3>
    <h4 class="text-left" style="margin-left: 50px; direction: ltr">
      التاريخ : {{ convertToUi(new Date()) }}
    </h4>

    <md-card-content dir="rtl" class="redirect-dir">
      <div class="md-layout">
        <div class="md-layout-item">
          <md-card style="box-shadow: none">
            <div
              style="margin-top: 10px; margin-bottom: 35px"
              class="marginTop"
            >
              <md-card-content>
                <md-table
                  class="paginated-table table-striped table-hover mt-25"
                >
                  <md-table-row>
                    <md-table-cell class="border-staffLists">ر.م</md-table-cell>

                    <md-table-cell class="border-staffLists"
                      >الاسم</md-table-cell
                    >

                    <md-table-cell
                      v-if="col_jobNumber"
                      class="w-130 border-staffLists"
                      >رقم الموظف</md-table-cell
                    >

                    <md-table-cell v-if="col_nat" class="border-staffLists"
                      >الرقم الوطني</md-table-cell
                    >

                    <md-table-cell v-if="col_d" class="border-staffLists"
                      >الادارة</md-table-cell
                    >

                    <md-table-cell v-if="col_jop" class="border-staffLists"
                      >الصفة الوظيفية</md-table-cell
                    >

                    <md-table-cell v-if="col_current" class="border-staffLists"
                      >الحالة الوظيفية</md-table-cell
                    >

                    <md-table-cell v-if="col_sci" class="border-staffLists"
                      >المؤهل العلمي</md-table-cell
                    >

                    <md-table-cell v-if="col_Grade" class="border-staffLists"
                      >الدرجة</md-table-cell
                    >

                    <md-table-cell v-if="col_Bonus" class="border-staffLists"
                      >العلاوة</md-table-cell
                    >
                  </md-table-row>
                  <md-table-row v-for="(item, i) in data" :key="i">
                    <md-table-cell class="border-staffLists" md-label="الصنف">{{
                      i + 1
                    }}</md-table-cell>

                    <md-table-cell class="border-staffLists" md-label="الصنف">{{
                      item.fullName
                    }}</md-table-cell>

                    <md-table-cell
                      v-if="col_jobNumber"
                      class="w-130 border-staffLists"
                      md-label="الصنف"
                      >{{ item.jobNumber }}</md-table-cell
                    >

                    <md-table-cell
                      v-if="col_nat"
                      class="border-staffLists"
                      md-label="الصنف"
                      >{{ item.nationalNumber }}</md-table-cell
                    >

                    <md-table-cell
                      v-if="col_d"
                      class="border-staffLists"
                      md-label="الصنف"
                      >{{ item.departmentName }}</md-table-cell
                    >

                    <md-table-cell
                      v-if="col_jop"
                      class="border-staffLists"
                      md-label="الصنف"
                      >{{ item.jobTitle }}</md-table-cell
                    >

                    <md-table-cell
                      v-if="col_current"
                      class="border-staffLists"
                      md-label="الصنف"
                      >{{ item.currentSituationString }}</md-table-cell
                    >

                    <md-table-cell
                      v-if="col_sci"
                      class="border-staffLists"
                      md-label="الصنف"
                      >{{ item.scientificDegreeName }}</md-table-cell
                    >

                    <md-table-cell
                      v-if="col_Grade"
                      class="border-staffLists"
                      md-label="الصنف"
                      >{{ item.currentGrade }}</md-table-cell
                    >

                    <md-table-cell
                      v-if="col_Bonus"
                      class="border-staffLists"
                      md-label="الصنف"
                      >{{ item.currentBonus }}</md-table-cell
                    >
                  </md-table-row>
                </md-table>
              </md-card-content>
            </div>
          </md-card>
        </div>
      </div>
    </md-card-content>

    <div class="md-layout text-center last-footer">
      <div class="md-layout-item md-size-50">
        <p class="fs-head" style="font-weight: bold">إعداد</p>
        <p class="fs-head" style="font-weight: bold">رئيس قسم شؤون الموظفين</p>
      </div>

      <div class="md-layout-item md-size-50">
        <p class="fs-head" style="font-weight: bold">إعتماد</p>
        <p class="fs-head" style="font-weight: bold">
          مدير إدارة الشؤون اللإدارية
        </p>
      </div>
    </div>

    <!-- <md-card-content dir="rtl" class="redirect-dir">
        
       
        <div style="margin-top: 100px; " class="container body">
              <div class="c-1">ر.ت</div>
              <div class="c-2">الإسم</div>
              <div class="c-3">رقم الموظف</div>
              <div class="c-4">الرقم الوطني</div>
              <div v-if="col_d" class="c-5">الادارة</div>
              <div class="c-6">الصفة الوظيفية</div>
              <div class="c-7"> الدرجة</div>
              <div class="c-8">العلاوة</div>
          </div>

          <div :style="i % 2 == 1 ? { 'background': '#f5f5f5' } : { 'background': '#fff' }" v-for="(item, i) in data"
              :key="i" class="container" :class="{'custom-mt' : (i+1) % 19 == 0 && i != 0 && i / 18 != 1 && (i+1) / 19 != countE   }"  >
              <div class="c-1">{{ item.num}}</div>
              <div class="c-2">{{ item.fullName }}</div>
              <div  class="c-3">{{ item.jobNumber }}</div> 
              <div  class="c-4">{{ item.nationalNumber }}</div> 
              <div v-if="col_d"  class="c-5">{{ item.departmentName }}</div> 
              <div  class="c-6">{{ item.jobTitle }}</div> 
              <div  class="c-7">{{ item.currentGrade  }}</div> 
              <div  class="c-8">{{ item.currentBonus }}</div> 
            </div>
      </md-card-content> -->
  </div>
</template>

<script>
//  import { count } from "console";
import env from "../../../env";

export default {
  mounted() {},
  props: [
    "name",
    "desc",
    "data",
    "pathLogo",
    "countE",
    "col_nat",
    "col_jobNumber",
    "col_sci",
    "col_d",
    "col_jop",
    "col_Grade",
    "col_Bonus",
    "DepartmentId",
    "col_current",
  ],
  data() {
    return {
      currentSort: "",
      currentSortOrder: "asc",
      m: env.mTop(),
    };
  },
  methods: {
    convert(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return "-";
        }
        return (
          d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate()

          // +
          // " , "
          // +
          // d.getHours() +
          // ":" +
          // d.getMinutes()
        );
      } catch (error) {}
    },
    convertToUi(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return " - ";
        }
        return (
          d.getDate() + " - " + (d.getMonth() + 1) + " - " + d.getFullYear()

          // +
          // " , "
          // +
          // d.getHours() +
          // ":" +
          // d.getMinutes()
        );
      } catch (error) {}
    },
    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;
        if (this.currentSortOrder === "desc") {
          return a[sortBy].localeCompare(b[sortBy]);
        }
        return b[sortBy].localeCompare(a[sortBy]);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/StaffLists";

.report-fs {
  * {
    font-size: 22px !important;
    font-family: "Cairo", sans-serif !important;
  }

  .md-table-head {
    .md-table-head-container {
      .md-table-head-label {
        font-size: 22px !important;
      }
    }
  }

  .fs-head-co {
    font-size: 29px !important;
    font-weight: bold;
  }

  .fs-head {
    font-size: 25px !important;
  }

  .custom-mt {
    margin-bottom: 440px;
  }

  .border-staffLists {
    border: 1px solid #000;
    /* border-left: none; */
    border-top: 1px solid #000 !important;
    height: 90px;
  }
}
</style>